import * as React from "react"
import { useEditorState } from "@tiptap/react"
import { Button } from "../../tiptap-ui-primitive/button"
import { useTiptapEditor } from "../../hooks/use-tiptap-editor"

export const CodeBlockButton: React.FC = () => {
  const editor = useTiptapEditor()

  const state = useEditorState({
    editor,
    selector: (ctx) => ({
      isActive: ctx.editor?.isActive("codeBlock") ?? false,
      canToggle: ctx.editor?.can().toggleCodeBlock() ?? false,
    }),
  })

  const handleClick = () => {
    if (!editor) return
    editor.chain().focus().toggleCodeBlock().run()
  }

  return (
    <Button
      onClick={handleClick}
      data-active={state.isActive}
      data-disabled={!state.canToggle}
      disabled={!state.canToggle}
      aria-label="Блок кода"
      title="Блок кода"
    >
      {"</>"}
    </Button>
  )
}
